import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Toolbar,
  Typography,
  AppBar,
  Menu,
  MenuItem,
  IconButton,
  Box,
} from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AccountCircle from "@mui/icons-material/AccountCircle";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import SettingsIcon from "@mui/icons-material/Settings";

import { logout } from "../lib/auth";
// jotai
import { useAtom, useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";
import { useWindowSize } from "../lib/useWindowSize";

function TopBar() {
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const [pathname, setPathname] = useAtom(AppAtoms.pathname);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { windowWidth, windowHeight } = useWindowSize();
  const [fontMarginTop, setFontMarginTop] = useState("-25px");
  const [logoMarginTop, setLogoMarginTop] = useState("-24px");
  const [systemTitle, setSystemTitle] = useState("");
  useEffect(() => {
    let fontMarginTop = "-25px";
    let logoMarginTop = "-24px";
    if (windowWidth < 600) {
      fontMarginTop = "-18px";
      logoMarginTop = "-15px";
    }
    setFontMarginTop(fontMarginTop);
    setLogoMarginTop(logoMarginTop);
  }, [windowWidth, windowHeight]);
  useEffect(() => {
    if (loginUser) {
      let systemTitle = loginUser.title;
      if (windowWidth > 599) {
        const subTitle =
          pathname === "/" || pathname === "/dashboard"
            ? "ダッシュボード"
            : pathname === "/contract"
              ? "エントリー管理"
              : pathname === "/entry_analysys"
                ? "エントリー分析"
                : pathname === "/toss_up_analysys"
                  ? "トスアップ分析"
                  : pathname === "/toss_up"
                    ? "トスアップ管理"
                    : pathname === "/runking"
                      ? "ランキング"
                      : pathname === "/payment_admin"
                        ? "明細管理"
                        : pathname === "/payment"
                          ? loginUser?.authority === "マスターアカウント"
                            ? "確定済 - 明細一覧"
                            : "明細一覧"
                          : /*
            : pathname === "/top-company"
            ? "上位店管理"
            */
                            pathname === "/product"
                            ? "商材管理"
                            : pathname === "/service"
                              ? "サービスプラン管理"
                              : pathname === "/incentive"
                                ? "インセンティブ管理"
                                : pathname === "/follow_call"
                                  ? "フォローコール一覧"
                                  : pathname === "/follow_call_config"
                                    ? "フォローコール設定"
                                    : pathname === "/column_config"
                                      ? "システム項目設定"
                                      : pathname === "/outside_entry_site"
                                        ? loginUser?.authority ===
                                            "マスターアカウント" ||
                                          loginUser?.authority ===
                                            "スタッフアカウント"
                                          ? "外部ETサイト管理"
                                          : loginUser?.db_authority !==
                                              "トスアップアカウント"
                                            ? "外部ETサイト"
                                            : ""
                                        : pathname === "/outside_entry_form"
                                          ? "外部ETフォーム管理"
                                          : pathname === "/entry_form"
                                            ? "エントリーフォーム管理"
                                            : pathname === "/toss_up_form"
                                              ? "トスアップフォーム管理"
                                              : pathname === "/partner"
                                                ? "パートナー管理"
                                                : pathname === "/config"
                                                  ? "企業・グループ管理"
                                                  : pathname === "/account"
                                                    ? "アカウント管理"
                                                    : pathname === "/profile"
                                                      ? "プロフィール"
                                                      : pathname ===
                                                          "/system_config"
                                                        ? "システム設定"
                                                        : pathname ===
                                                            "/product_partner_result"
                                                          ? "推進実績"
                                                          : pathname ===
                                                              "/inquiry"
                                                            ? "システム問い合わせ"
                                                            : null;
        systemTitle += "　-　" + subTitle;
      }
      setSystemTitle(systemTitle);
    }
  }, [windowWidth, loginUser, pathname]);

  return (
    <AppBar
      position={isSmartPhone ? "fixed" : "static"}
      style={{
        boxShadow: "none",
        height: "40px",
      }}
      sx={{
        backgroundColor: "primary.dark",
      }}
    >
      <Toolbar>
        <Typography
          variant="h5"
          component="div"
          sx={{
            flexGrow: 1,
          }}
        >
          <Box
            className="noto-sans-jp-regular"
            style={{
              display: "flex",
              fontSize: "18px",
              marginTop: fontMarginTop,
            }}
          >
            {systemTitle}
          </Box>
        </Typography>
        {windowWidth > 400 ? (
          <Box
            className="noto-sans-jp-regular"
            sx={{
              marginRight: "15px",
              fontSize: "18px",
              marginTop: fontMarginTop,
            }}
          >
            {loginUser?.username}
          </Box>
        ) : null}
        <IconButton
          size="small"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="default"
          sx={{
            marginTop: logoMarginTop,
          }}
        >
          <AccountCircle
            fontSize="large"
            sx={{ color: "rgb(230 230 230)", width: "25px", height: "25px" }}
          />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {loginUser?.authority === "マスターアカウント" ? (
            <Link
              style={{ color: "inherit", textDecoration: "none" }}
              to={"/system_config"}
              onClick={() => {
                setPathname("/system_config");
                handleClose();
              }}
            >
              <MenuItem>
                <Box className="header-manu">システム設定</Box>
                <SettingsIcon
                  style={{ marginLeft: "11px" }}
                  fontSize="medium"
                  color="action"
                />
              </MenuItem>
            </Link>
          ) : null}
          <Link
            style={{ color: "inherit", textDecoration: "none" }}
            to={"/profile"}
            onClick={() => {
              setPathname("/profile");
              handleClose();
            }}
          >
            <MenuItem>
              <Box className="header-manu">プロフィール</Box>
              <AccountBoxIcon
                style={{ marginLeft: "11px" }}
                fontSize="medium"
                color="action"
              />
            </MenuItem>
          </Link>
          <MenuItem onClick={logout}>
            <Box className="header-manu">ログアウト</Box>
            <ExitToAppIcon
              style={{ marginLeft: "26px" }}
              fontSize="medium"
              color="action"
            />
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
